function Project() {
  return (
    <div>
      <div className="w-full flex justify-center items-center">
        <div className="flex w-full min-h-[30vh] md:min-h-[70vh]">
          <div className="bg-[rgba(89,120,148,0.5)] w-full md:w-1/2 min-h-full flex justify-center items-center">
            <div className="">
              <h1 className="lg:text-4xl md:text-3xl text-2xl font-semibold text-center ">
                Data Driven Material Design
              </h1>
              <h1 className="lg:text-3xl md:text-2xl text-2xl font-semibold text-center">
                Lab
              </h1>
            </div>
          </div>
          <div className="w-[50%] bg-[rgb(97,120,161)] flex justify-center items-center">
            <img
              className="w-[285px] h-[244px] object-cover rounded-md mb-2"
              src="/images/pandat_2(2).png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div>ddd</div>
    </div>
  );
}

export default Project;
